module.exports = __webpack_public_path__ + "img/uicaster_banner.573077ae.jpg";